import React from 'react';
import styled from 'styled-components';
import ModsyHeart from 'web-ui-kit/assets/ModsyHeart';
import { backgroundMediumM, grayLightM } from 'web-ui-kit/colors';
import ImageWithFallback from 'web-ui-kit/images/ImageWithFallback';
import { Header5LargeStyles, BodySmallSmallStyles } from 'web-ui-kit/typography';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
/**
 * A content box that displays curated product comments.
 */


function CuratedComment(_ref) {
  var _commenter$firstName, _commenter$avatarSrc, _commentObj$comment;

  var _ref$curatedRec = _ref.curatedRec,
      curatedRec = _ref$curatedRec === void 0 ? {} : _ref$curatedRec,
      _ref$mqSingleColumnBe = _ref.mqSingleColumnBelow,
      mqSingleColumnBelow = _ref$mqSingleColumnBe === void 0 ? '' : _ref$mqSingleColumnBe,
      _ref$mqTwoColumnUp = _ref.mqTwoColumnUp,
      mqTwoColumnUp = _ref$mqTwoColumnUp === void 0 ? '' : _ref$mqTwoColumnUp,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant;
  var commentObj = curatedRec === null || curatedRec === void 0 ? void 0 : curatedRec.comment;
  var commenter = commentObj === null || commentObj === void 0 ? void 0 : commentObj.commenter;
  var commenterFirstName = (_commenter$firstName = commenter === null || commenter === void 0 ? void 0 : commenter.firstName) !== null && _commenter$firstName !== void 0 ? _commenter$firstName : 'your designer';
  var commenterAvatarSrc = (_commenter$avatarSrc = commenter === null || commenter === void 0 ? void 0 : commenter.avatarSrc) !== null && _commenter$avatarSrc !== void 0 ? _commenter$avatarSrc : '';
  var comment = (_commentObj$comment = commentObj === null || commentObj === void 0 ? void 0 : commentObj.comment) !== null && _commentObj$comment !== void 0 ? _commentObj$comment : '';
  var Avatar = styles.Avatar,
      AvatarFallbackContainer = styles.AvatarFallbackContainer,
      Container = styles.Container,
      Heading = styles.Heading,
      Paragraph = styles.Paragraph;

  if (!comment) {
    return null;
  }

  var AvatarFallbackComponent =
  /*#__PURE__*/
  React.createElement(AvatarFallbackContainer, null,
  /*#__PURE__*/
  React.createElement(ModsyHeart, {
    variant: 'avatarLarge'
  }));
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "curated-comment-".concat(variant),
      mqSingleColumnBelow: mqSingleColumnBelow,
      mqTwoColumnUp: mqTwoColumnUp,
      variant: variant
    },
    /*#__PURE__*/
    React.createElement(Avatar, {
      alt: commenterFirstName,
      bucketName: "modsy",
      fallbackComponent: AvatarFallbackComponent,
      src: commenterAvatarSrc,
      width: 40,
      height: 40
    }),
    /*#__PURE__*/
    React.createElement(Heading, null, "Advice from ".concat(commenterFirstName)),
    /*#__PURE__*/
    React.createElement(Paragraph, null, comment))
  );
}

var styles = {
  Container: styled.section(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 40px 1fr;\n    grid-template-areas:\n      \"avatar heading\"\n      \"avatar comment\";\n    grid-column-gap: 0.75rem;\n\n    background-color: ", ";\n    padding: 1rem;\n\n    ", " {\n      ", "\n    }\n\n    ", " {\n      border-radius: 4px;\n\n      ", "\n    }\n  "])), backgroundMediumM, function (p) {
    return p.mqSingleColumnBelow;
  }, function (p) {
    return p.variant === 'two-column' && "\n        display: none;\n      ";
  }, function (p) {
    return p.mqTwoColumnUp;
  }, function (p) {
    return p.variant === 'single-column' && "\n        display: none;\n      ";
  }),
  Avatar: styled(ImageWithFallback)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-area: avatar;\n    border: 1px solid ", ";\n    border-radius: 50%;\n  "])), grayLightM),
  AvatarFallbackContainer: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-area: avatar;\n  "]))),
  Heading: styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-area: heading;\n    ", ";\n  "])), Header5LargeStyles),
  Paragraph: styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-area: comment;\n    ", ";\n  "])), BodySmallSmallStyles)
};
export default CuratedComment;